import {createAction} from '@reduxjs/toolkit'
import {isEventDetailsPageHiddenInternal} from '@wix/wix-events-commons-statics'
import {Dispatch} from 'redux'
import {Routes} from '../../../../commons/enums'
import * as navigation from '../../../../commons/services/navigation'
import {getNoEventsPage} from '../selectors/component'
import {getNoUpcomingEventsPageId} from '../selectors/navigation'
import {createAsyncAction} from '../services/redux-toolkit'
import {DetailedEvent, GetState, RouteParams, StoreExtraArgs} from '../types/state'

export const UPDATE_NO_EVENT_URL_OLD = 'UPDATE_NO_EVENT_URL_OLD'

export const navigateToDetailsPageOld =
  (event: DetailedEvent) =>
  async (dispatch: Dispatch, _getState: GetState, {wixCodeApi}: StoreExtraArgs) => {
    dispatch(navigateToDetailsPageClicked())

    const detailsPageEnabled = !isEventDetailsPageHiddenInternal(event.event)

    await navigation.navigateToDetailsPage(event.event, detailsPageEnabled, wixCodeApi)
  }

export const navigateToDetailsPage = createAsyncAction<void, {event: DetailedEvent}>(
  'NAVIGATE_TO_DETAILS_PAGE',
  async ({event}, {dispatch, extra: {wixCodeApi}}) => {
    dispatch(navigateToDetailsPageClicked())

    const detailsPageEnabled = !isEventDetailsPageHiddenInternal(event.event)

    await navigation.navigateToDetailsPage(event.event, detailsPageEnabled, wixCodeApi)
  },
)

export const updateNoEventsUrlOld =
  () =>
  async (dispatch: Function, getState: GetState, {wixCodeApi, flowAPI}: StoreExtraArgs) => {
    const page = (await getNoEventsPage({wixCodeApi, flowAPI, state: getState()})) as any
    const url = `${wixCodeApi.location.baseUrl}${page.prefix ? `/${page.prefix}` : ''}${page.url}`

    return dispatch({
      type: UPDATE_NO_EVENT_URL_OLD,
      payload: {
        url,
        pageId: page.id,
      },
    })
  }

export const updateNoEventsUrl = createAsyncAction<{url: string; pageId: string}, void>(
  'UPDATE_NO_EVENT_URL',
  async (_, {getState, extra: {wixCodeApi, flowAPI}}) => {
    const page = (await getNoEventsPage({wixCodeApi, flowAPI, state: getState()})) as any
    const url = `${wixCodeApi.location.baseUrl}${page.prefix ? `/${page.prefix}` : ''}${page.url}`

    return {
      url,
      pageId: page.id,
    }
  },
)

export const navigateToDetailsPageClicked = createAction('NAVIGATE_TO_DETAILS_PAGE')

export const internalNavigate = createAction<{route: Routes; params?: RouteParams}>('INTERNAL_NAVIGATE')

export const navigateToNoUpcomingEventsUrlOld =
  () =>
  (_dispatch: Function, getState: GetState, {wixCodeApi}: StoreExtraArgs) =>
    wixCodeApi.location.navigateTo({pageId: getNoUpcomingEventsPageId(getState())})

export const navigateToNoUpcomingEventsUrl = createAsyncAction<void, void>(
  'NAVIGATE_TO_NO_UPCOMING_EVENTS_URL',
  async (_, {getState, extra: {wixCodeApi}}) =>
    wixCodeApi.location.navigateTo({pageId: getNoUpcomingEventsPageId(getState())}),
)
